import { render, staticRenderFns } from "./DetailsDebrisTypesDepartments.vue?vue&type=template&id=7766f0c3&scoped=true&"
import script from "./DetailsDebrisTypesDepartments.vue?vue&type=script&lang=js&"
export * from "./DetailsDebrisTypesDepartments.vue?vue&type=script&lang=js&"
import style0 from "./DetailsDebrisTypesDepartments.vue?vue&type=style&index=0&id=7766f0c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7766f0c3",
  null
  
)

export default component.exports